// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import { gsap } from "gsap";
import { lockScroll, unlockScroll } from "../../../modules/scrollLock";

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// —————————————————————————————————————— INIT. METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_modals() {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const el_body = document.body;

  ///// Modal open-anim. config. /////
  ////////////////////////////////////

  const dur_open = 0.4;
  const dur_close = 0.5;
  const y_open = "0vh";
  const y_close = "25vh";
  const ease_open = "power2.out";
  const ease_close = "power2.out";

  function openCloseModal(m, action) {
    gsap.to(m, {
      duration: action === "open" ? dur_open : dur_close,
      y: action === "open" ? y_open : y_close,
      opacity: action === "open" ? 1 : 0,
      ease: action === "open" ? ease_open : ease_close,
      onComplete: () => {
        m.dataset.active = action === "open" ? "true" : "false";
        action === "open" ? lockScroll(el_body) : unlockScroll(el_body);
        if (action === "close") m.scrollTop = 0;
      },
    });
  }

  //////////////////////////////////////////// ACTION ////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  ///////////////////// Funding-format modals init. //////////////////////
  ////////////////////////////////////////////////////////////////////////

  // Check for modal el. refs.
  const modals_fundFormat = document.querySelectorAll("[data-ref='modal_fundFormat']");
  if (modals_fundFormat && modals_fundFormat.length > 0) {
    // Add modal els. to comp. refs.
    const arr_modals_fundFormat = Array.from(modals_fundFormat);
    this.ref.modals_fundFormat = arr_modals_fundFormat;

    // Init. modals
    modals_fundFormat.forEach((m) => {
      const btn_close = m.querySelector("[data-ref='btn_close']");
      if (!btn_close) return;
      btn_close.addEventListener("click", () => openCloseModal(m, "close"));
    });

    // Init. closing of modal on click outside of modal el.
    document.addEventListener("click", (e) => {
      const modal_toClose = arr_modals_fundFormat.find((m) => m.dataset.active === "true");
      const wrpr_content_modal_toClose = modal_toClose ? modal_toClose.querySelector("[data-ref='wrpr_content']") : null;
      if (modal_toClose && !wrpr_content_modal_toClose.contains(e.target)) openCloseModal(modal_toClose, "close");
    });

    // Init. corresp. btn. click hdl. on funding-format items on page
    const { items_fundFormat } = this.ref;
    items_fundFormat.forEach((it) => {
      const btn_openModal = it.querySelector("[data-ref='btn_openModal']");
      if (!btn_openModal) return;
      btn_openModal.addEventListener("click", () => {
        const modal_toClose = arr_modals_fundFormat.find((m) => m.dataset.active === "true");
        const modal_toOpen = arr_modals_fundFormat.find((m) => m.dataset.id === btn_openModal.dataset.id);
        if (modal_toOpen) openCloseModal(modal_toOpen, "open");
        if (modal_toClose && modal_toClose !== modal_toOpen) openCloseModal(modal_toClose, "close");
      });
    });
  }

  /////////////////////////////////////////// Conclude ///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // ...
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
